import styled from 'styled-components';
import { Box } from 'vqp-common';
import { Button } from '../../../components/common';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 13px;
`;

export const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.primary};
  border-bottom: 1px solid ${(props) => props.theme.colors.lineGrey};
`;

export const SubTitle = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 15px;
  font-weight: 700;
  width: 100%;
  color: ${(props) => props.theme.colors.primary};
  margin-bottom: 0.6rem;
`;

export const Description = styled.p`
  font-size: 13px;
  color: ${(props) => props.theme.colors.textPrimary};
  margin: 0;
`;

export const Card = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
`;

export const Col1 = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 20px;
  margin: 35px 20px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  flex-grow: 1;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  width: 31%;
  margin-right: 20px;
  margin-bottom: 15px;
`;

export const CustomLabel = styled.span`
  font-size: 12px;
  color: ${(props) => props.theme.colors.textPrimary};
  margin: 0 0 4px 0;
`;

export const CustomAlert = styled.div`
  color: ${(props) => props.theme.colors.white};
  background-color: ${(props) => props.theme.colors.secondWarning};
  border-radius: 5px;
  padding: 0.3rem;
  text-align: center;
`;

export const Strong = styled.span`
  font-weight: bold;
  font-size: 16px;
  color: ${(props) => props.theme.colors.primary};
`;

export const CustomIcon = styled.div`
  cursor: pointer;
  margin: 6px;
`;

export const Action = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const NewProductButton = styled(Button)`
  margin-left: auto;

  &.create {
    margin-top: -55px;
  }
`;

export const DeleteButton = styled(Button)`
  margin: 20px 0 6px 0;
`;

export const LoadingWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 2;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Span = styled.div`
  color: ${(props) => props.theme.colors.textBold};
  font-size: 14px;
`;

export const StatusBadge = styled.span`
  display: inline-block;
  min-width: 78px;
  padding: 5px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  background-color: ${(props) => (props.active ? props.theme.colors.lightGreen : '#E6E6E6')};
  color: ${(props) => (props.active ? '#fff' : props.theme.colors.mediumGrey)};
`;
